import { render } from "./Info.vue?vue&type=template&id=af58b51a&scoped=true&ts=true"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"

import "./Info.vue?vue&type=style&index=0&id=af58b51a&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af58b51a"]])

export default __exports__